import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

class ReactTableFilterSelect extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.currentValue !== nextProps.currentValue) {
            return true;
        } else if (!_.isEqual(nextProps.optionsObject, this.props.optionsObject)) {
            return true;
        } else if (!_.isEqual(nextProps.style, this.props.style)) {
            return true;
        }
        return false;
    }

    handleChange = (event) => {
        if (this.props.multiple) {
            const selectedOptions = [].slice
                .call(event.target.selectedOptions)
                .map(o => o.value);
            this.props.onChange(selectedOptions);
        } else {
            this.props.onChange(event.target.value);
        }
    };

    render () {
        const {
            style,
            multiple,
            currentValue
        } = this.props;

        let value;
        if (multiple) {
            value = Array.isArray(currentValue) ? currentValue : [];
        } else {
            value = currentValue;
        }

        return (
            <select
                onChange={this.handleChange}
                style={style}
                value={value}
                multiple={this.props.multiple}
            >
                {this.props.showAllOption ?
                    <option value={multiple ? [] : ""}>
                        Show All
                    </option>
                : null}

                {Object.keys(this.props.optionsObject).map(value =>
                    <option key={value} value={value}>
                        {this.props.optionsObject[value]}
                    </option>)}
            </select>
        );
    }
}

ReactTableFilterSelect.defaultProps = {
    showAllOption: false,
    multiple: false
};

ReactTableFilterSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    currentValue: PropTypes.any.isRequired,
    optionsObject: PropTypes.object.isRequired,
    showAllOption: PropTypes.bool.isRequired,
    multiple: PropTypes.bool.isRequired
};

export default ReactTableFilterSelect;



// WEBPACK FOOTER //
// ./src/helpers/react-table-filter-select.js